import React, { useEffect, useState } from 'react';
import Icon from '../../design-system/primitives/Icon';

/**
 * Wraps a block that scrolls and adds a bottom-right toggle that lifts it to
 * the full viewport. `children` is a render prop receiving `expanded`, so the
 * block can grow its scroll area to match. Escape or the toggle closes it.
 */
const Expandable = ({ children }) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!expanded) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setExpanded(false); };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [expanded]);

  return (
    <>
      {expanded && <div className="qa-expandable__backdrop" onClick={() => setExpanded(false)} />}
      <div className={`qa-expandable ${expanded ? 'qa-expandable--open' : ''}`}>
        {children(expanded)}
        <button
          type="button"
          className="qa-expand-btn"
          title={expanded ? 'Back to page (Esc)' : 'Expand to full width'}
          aria-label={expanded ? 'Back to page' : 'Expand to full width'}
          onClick={() => setExpanded((v) => !v)}
        >
          <Icon name={expanded ? 'minimize-2' : 'maximize-2'} size={13} />
        </button>
      </div>
    </>
  );
};

// Scroll height for a table inside an expanded block: viewport minus block chrome.
export const expandedMaxHeight = 'calc(100vh / var(--app-zoom, 1) - 150px)';

export default Expandable;
